export const PACKAGE_TYPES = [
  { value: "EUR", label: "EUR Pallet" },
  { value: "BOX", label: "Box" },
  { value: "PLT", label: "Pallet" },
  { value: "PCS", label: "Pieces" },
  { value: "CTN", label: "Carton" },
  { value: "BAG", label: "Bag" },
  { value: "DRM", label: "Drum" },
  { value: "CYL", label: "Cylinder" },
  { value: "FTL", label: "FTL" },
  { value: "LTL", label: "LTL" },
  { value: "OTHER", label: "Other" },
];

export const CURRENCIES = [
  { label: "Euro (€)", value: "EUR" },
  { label: "US Dollar ($)", value: "USD" },
  { label: "British Pound (£)", value: "GBP" },
  { label: "Pakistani Rupee (₨)", value: "PKR" },
  { label: "UAE Dirham (د.إ)", value: "AED" },
];

export const IMO_CLASS_OPTIONS = [
  { value: "Class1", label: "Class 1 - Explosives" },
  { value: "Class2", label: "Class 2 - Gases" },
  { value: "Class3", label: "Class 3 - Flammable Liquids" },
  { value: "Class4", label: "Class 4 - Flammable Solids" },
  { value: "Class5", label: "Class 5 - Oxidizing Substances" },
  { value: "Class6", label: "Class 6 - Toxic Substances" },
  { value: "Class7", label: "Class 7 - Radioactive Material" },
  { value: "Class8", label: "Class 8 - Corrosive Substances" },
  { value: "Class9", label: "Class 9 - Miscellaneous" },
];

export const STATUS_STEPS = [
  { key: "Order", label: "Order", description: "Initial creation" },
  {
    key: "ReadyForPickup",
    label: "Ready For Pickup",
    description: "Ready for collection",
  },
  {
    key: "AwaitingPickup",
    label: "Picked Up",
    description: "Shipment is Picked up",
  },
  { key: "InTransit", label: "In Transit", description: "Journey in progress" },
  {
    key: "Completed",
    label: "Completed",
    description: "Delivered successfully",
  },
];

export const PreviewableExtensions = [
  "pdf",
  "jpeg",
  "jpg",
  "png",
  "gif",
  "txt",
];
